import { IAccThietLapNganHangVm } from "./../../../model/respone/category/IAccThietLapNganHang";
import { IGenQRRequest } from "./../../../model/request/ngan-hang/IGenQRRequest";
import { IAccThietLapNganHang } from "../../../model/respone/category/IAccThietLapNganHang";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import { ITraSoatQRRespone } from "../../../model/respone/ngan-hang/ITraSoatQRRespone";
import { ITraSoatQRRequest } from "../../../model/request/ngan-hang/ITraSoatQRRequest";
import { IQRCodeResponse } from "../../../model/respone/ngan-hang/IQRCodeResponse";

export const eNganHangActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IAccThietLapNganHangVm[],
  LOAD_ERRR: "",

  LOAD_BANK_START: "",
  LOAD_BANK_SUCCESS: {} as any[],
  LOAD_BANK_ERRR: "",

  SAVE_START: {} as IAccThietLapNganHangVm,
  SAVE_SUCCESS: {} as IAccThietLapNganHangVm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  GENQR_START: {} as IGenQRRequest,
  GENQR_SUCCESS: {} as IQRCodeResponse,
  GENQR_ERROR: "",

  REMOVE_QR: undefined,

  TRA_SOAT_START: {} as ITraSoatQRRequest,
  TRA_SOAT_SUCCESS: {} as ITraSoatQRRespone,
  TRA_SOAT_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | IAccThietLapNganHang,
  CLOSE_EDIT_MODAL: undefined,
};
export const eNganHangActionIds = generateActionTypeIds(
  eNganHangActionsObj,
  "NGAN_HANG"
);
export type INganHangActionTypes = IGenericActionType<
  typeof eNganHangActionsObj,
  "NGAN_HANG"
>;
